/**
 * Yumi Kids - Automatic Complimentary Packaging (Yellow Drawstring Bag)
 * 
 * Automatically includes the Yellow Drawstring Bag on orders of ₹1,000 and above.
 * Handles:
 * - Dynamic addition when subtotal >= ₹1,000 without requiring page reload.
 * - Dynamic removal when subtotal drops below ₹1,000 without requiring page reload.
 * - Real-time Cart Drawer (mini-cart-drawer) & Cart Page re-rendering.
 * - Quantity locking to 1.
 */

(function () {
  'use strict';

  var CONFIG = window.YUMI_FREE_GIFT || {};
  if (CONFIG.enabled === undefined) CONFIG.enabled = true;
  if (CONFIG.minAmount === undefined || CONFIG.minAmount === null) CONFIG.minAmount = 1000; // Minimum order threshold in ₹
  if (!CONFIG.productId) CONFIG.productId = 15250715345268;
  if (!CONFIG.handle) CONFIG.handle = 'free-drawstring-bag';
  if (!CONFIG.title) CONFIG.title = 'Free Drawstring Bag';
  if (!CONFIG.badge) CONFIG.badge = '🎁 Complimentary Packaging';
  if (!CONFIG.originalPrice) CONFIG.originalPrice = '₹200';

  var isSyncing = false;

  // Helper to test if a line item is the complimentary gift
  function isComplimentaryItem(item) {
    if (!item) return false;
    if (item.properties && (item.properties._is_free_gift === 'true' || item.properties.Complimentary)) return true;
    if (CONFIG.variantId && item.variant_id == CONFIG.variantId) return true;
    if (CONFIG.productId && item.product_id == CONFIG.productId) return true;
    
    var handle = (item.handle || '').toLowerCase();
    var title = (item.title || item.product_title || '').toLowerCase();
    if (handle.indexOf('drawstring') !== -1 || handle.indexOf('free-drawstring') !== -1) return true;
    if (title.indexOf('drawstring') !== -1 || title.indexOf('free drawstring') !== -1) return true;
    return false;
  }

  // Get array of section IDs to request from Shopify AJAX API
  function getSectionsToRender() {
    var sections = ['mini-cart-drawer', 'cart-notification-count'];
    var mainCart = document.getElementById('main-cart-items');
    if (mainCart && mainCart.dataset.id) {
      sections.push(mainCart.dataset.id);
    }
    return sections;
  }

  // Helper to fetch the free gift variant ID if not pre-populated
  async function getFreeGiftVariantId() {
    if (CONFIG.variantId) return CONFIG.variantId;

    try {
      var res = await fetch('/products/' + (CONFIG.handle || 'free-drawstring-bag') + '.js');
      if (res.ok) {
        var product = await res.json();
        if (product.variants && product.variants.length > 0) {
          CONFIG.variantId = product.variants[0].id;
          if (window.YUMI_FREE_GIFT) {
            window.YUMI_FREE_GIFT.variantId = CONFIG.variantId;
          }
          return CONFIG.variantId;
        }
      }
    } catch (e) {
      console.warn('[Yumi Free Gift] Could not fetch product JSON:', e);
    }
    return null;
  }

  // Render updated sections into the Cart Drawer and Cart Page dynamically
  function renderCart(parsedState) {
    if (!parsedState) return;

    // Normalise structure: Shopify returns { sections: { ... } } or { "mini-cart-drawer": "..." }
    var sectionsData = parsedState.sections || parsedState;
    if (!sectionsData || typeof sectionsData !== 'object') return;

    var normalizedState = { sections: sectionsData };

    // 1. Update via theme's native CartNotification web component if available
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      try {
        cartNotification.renderContents(normalizedState);
      } catch (err) {
        console.warn('[Yumi Free Gift] cartNotification.renderContents error:', err);
      }
    }

    // 2. Direct DOM replacement fallback for the mini cart drawer
    if (sectionsData['mini-cart-drawer']) {
      var drawerEl = document.getElementById('mini-cart-drawer');
      if (drawerEl) {
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sectionsData['mini-cart-drawer'], 'text/html');
          var content = doc.querySelector('.shopify-section') || doc.body;
          if (content) {
            drawerEl.innerHTML = content.innerHTML;
          }
        } catch (e) {}
      }
    }

    // 3. Update cart count badges (desktop & mobile)
    if (sectionsData['cart-notification-count']) {
      try {
        var parser = new DOMParser();
        var doc = parser.parseFromString(sectionsData['cart-notification-count'], 'text/html');
        var countContent = doc.querySelector('.shopify-section') || doc.body;
        if (countContent) {
          var countElements = document.querySelectorAll(
            '#cart-notification-count, #cart-notification-count-mobile, .cart-count-bubble, .header__cart-count'
          );
          countElements.forEach(function (el) {
            el.innerHTML = countContent.innerHTML;
          });
        }
      } catch (e) {}
    }

    // 4. Update main-cart-items if currently on the full /cart page
    var mainCart = document.getElementById('main-cart-items');
    if (mainCart && mainCart.dataset.id && sectionsData[mainCart.dataset.id]) {
      try {
        var parser = new DOMParser();
        var doc = parser.parseFromString(sectionsData[mainCart.dataset.id], 'text/html');
        var mainContent = doc.querySelector('#main-cart-items') || doc.querySelector('.shopify-section') || doc.body;
        if (mainContent) {
          mainCart.innerHTML = mainContent.innerHTML;
        }
      } catch (e) {}
    }
  }

  // Refresh cart drawer dynamically via Shopify's Section Rendering API
  async function triggerCartRefresh() {
    try {
      var sections = getSectionsToRender();
      var url = window.location.pathname + '?sections=' + sections.join(',');
      var res = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      if (res.ok) {
        var data = await res.json();
        renderCart(data);
      }
    } catch (err) {
      console.warn('[Yumi Free Gift] triggerCartRefresh error:', err);
    }
  }

  // Main synchronization engine
  async function syncFreeGiftCart(cartData) {
    if (isSyncing) return;
    if (CONFIG.enabled === false) return;

    try {
      var cart = cartData;
      if (!cart || !cart.items) {
        var res = await fetch('/cart.js');
        cart = await res.json();
      }

      var regularItems = [];
      var complimentaryItems = [];

      cart.items.forEach(function (item) {
        if (isComplimentaryItem(item)) {
          complimentaryItems.push(item);
        } else {
          regularItems.push(item);
        }
      });

      var regularCount = regularItems.reduce(function (sum, it) { return sum + it.quantity; }, 0);
      var regularSubtotal = regularItems.reduce(function (sum, it) {
        return sum + (it.final_line_price || it.line_price || (it.price * it.quantity) || 0);
      }, 0);

      var freeGiftItem = complimentaryItems[0] || null;

      // Minimum threshold calculation (₹1,000 = 100,000 paise)
      var minAmountRupees = (CONFIG.minAmount !== undefined && CONFIG.minAmount !== null) ? Number(CONFIG.minAmount) : 1000;
      var minAmountPaise = minAmountRupees * 100;
      var qualifiesForFreeGift = (regularCount > 0) && (regularSubtotal >= minAmountPaise);

      // Scenario 1: Cart qualifies for free gift (>= ₹1,000), but FREE GIFT is missing -> Add it & update drawer!
      if (qualifiesForFreeGift && !freeGiftItem) {
        isSyncing = true;
        var variantId = await getFreeGiftVariantId();
        if (variantId) {
          var addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: {
                  '_is_free_gift': 'true',
                  'Complimentary': 'Yellow Drawstring Bag'
                }
              }],
              sections: getSectionsToRender(),
              sections_url: window.location.pathname
            })
          });

          if (addRes.ok) {
            var state = await addRes.json();
            renderCart(state);
          } else {
            await triggerCartRefresh();
          }
        }
        isSyncing = false;
        return;
      }

      // Scenario 2: Cart does NOT qualify (< ₹1,000 or empty), but free gift IS in cart -> Auto-remove & update drawer!
      if (!qualifiesForFreeGift && complimentaryItems.length > 0) {
        isSyncing = true;
        var updates = {};
        complimentaryItems.forEach(function (it) {
          updates[it.key] = 0;
        });

        var removeRes = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            updates: updates,
            sections: getSectionsToRender(),
            sections_url: window.location.pathname
          })
        });

        if (removeRes.ok) {
          var state = await removeRes.json();
          renderCart(state);
        } else {
          await triggerCartRefresh();
        }
        isSyncing = false;
        return;
      }

      // Scenario 3: Cart qualifies, free gift is in cart, but quantity is != 1 or duplicate exists -> Lock to exactly 1
      if (qualifiesForFreeGift && complimentaryItems.length > 0) {
        var updates = {};
        var needsUpdate = false;
        complimentaryItems.forEach(function (item, index) {
          if (index === 0) {
            if (item.quantity !== 1) {
              updates[item.key] = 1;
              needsUpdate = true;
            }
          } else {
            updates[item.key] = 0;
            needsUpdate = true;
          }
        });

        if (needsUpdate) {
          isSyncing = true;
          var lockRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              updates: updates,
              sections: getSectionsToRender(),
              sections_url: window.location.pathname
            })
          });

          if (lockRes.ok) {
            var state = await lockRes.json();
            renderCart(state);
          } else {
            await triggerCartRefresh();
          }
          isSyncing = false;
          return;
        }
      }

    } catch (err) {
      console.warn('[Yumi Free Gift] Sync error:', err);
    } finally {
      isSyncing = false;
    }
  }

  // Hook into native fetch to detect any Cart modifications automatically
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] || '').toString();

    return originalFetch.apply(this, args).then(function (response) {
      if (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      ) {
        // Clone response to avoid consuming the stream
        response.clone().json().then(function (data) {
          if (!isSyncing) {
            setTimeout(function () {
              syncFreeGiftCart();
            }, 120);
          }
        }).catch(function () {});
      }
      return response;
    });
  };

  // Expose global helper
  window.YumiFreeGift = {
    sync: syncFreeGiftCart,
    isComplimentary: isComplimentaryItem,
    getVariantId: getFreeGiftVariantId,
    refreshCart: triggerCartRefresh
  };

  // Run on page load & tab display
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncFreeGiftCart();
    });
  } else {
    syncFreeGiftCart();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      syncFreeGiftCart();
    }
  });

})();
